module.exports = __webpack_public_path__ + "static/facebook_login-cc672c998352c53675b8b4b6e0ca8cd2.png";